import apiClient from './axiosClient';

export const profileApi = {
    getProfile: async(params) => {
        const res = await apiClient.get(`/api/provider/users/by-username/${params.userName}`);
        const data = res?.data;       

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    sendMFAEnableVerCode: async(params) => {
        const res = await apiClient.get(`/api/provider/profile/sendMFAEnableVerCode?email=${params.email}`);
        const data = res?.data;      

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    verifyMFAEnableVerCode: async (params) => {
        
        const res = await apiClient.post(`/api/provider/profile/verifyMFAEnableVerCode`, {
            email: params.email,
            verificationSecretKey: params.verificationSecretKey,
            verificationCode: params.verificationCode
        });
        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },


    update2FA: async (params) => {
        
        const res = await apiClient.post('/api/auth/toggle-2fa', {
            username: params.username,
            enable: params.enable
            
        });
        const data = res?.data;
        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
        

    updateProfile: async (params) => {
        // apiClient.put('/profile', data),

        //alert("AT updateProfile : "+JSON.stringify(params));
        //console.log("AT updateProfile : "+JSON.stringify(params));

        //return;
        const res = await apiClient.put('/api/provider/users/update', {
            userId:params.userId,
            firstName: params.firstName,
            lastName: params.lastName,
            phone: params.phone,
            orgName: params.orgName,
            userRole: params.userRole,
            status:true,
            taxIds: params.taxIds
        });
        const data = res?.data;
        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    changePassword: async (params) => {
        const res = await apiClient.post('/api/auth/change-password', {
            currentPassword: params.currentPassword,
            newPassword: params.newPassword,
            username:params.userName
        });
        const data = res?.data;     
        

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };

    },
    getRecordedImpersonatedUserEvent: async (params) => {

        var res = await apiClient.get(`/api/provider/user/profile/getRecordedImpersonatedUserEvents?UserId=` + params.userId);

        const data = res?.data;


        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    getRecordedEvent: async (params) => {

        var res = await apiClient.get(`/api/provider/user/profile/getRecordedUserEvents?UserId=` + params.userId);

        const data = res?.data;


        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    deleteRecorderUserEvent: async (params) => {

        var res = await apiClient.delete(`/api/provider/user/profile/deleteRecordedUserEvents?UserId=` + params.userId);

        const data = res?.data;


        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },    
    deleteRecorderImpersonationUserEvent: async (params) => {

        var res = await apiClient.delete(`/api/provider/user/profile/deleteRecordedImpersonatedUserEvents?UserId=` + params.userId);

        const data = res?.data;


        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },   
  

    updateNotificationPreferences: async (params) => {
        
        
        const res = await apiClient.put('/api/provider/users/update-notification-preferences', {
            notificationPreferences:  params.notificationPreferences
        });
        const data = res?.data;
        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    }
};
